import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

try {
    platformBrowserDynamic().bootstrapModule(AppModule)
        .then(ref => {
            // Ensure Angular destroys itself on hot reloads.
            if (window['ngRef']) {
                window['ngRef'].destroy();
            }
            window['ngRef'] = ref;
        })
        // Otherwise, log the boot error
        .catch(defaultErrorLogger);
} catch (e) {
    // logs `Can't resolve all parameters for App: (?)`
     console.error('Main error', e);
}


function defaultErrorLogger() {

    const values = [];
    for (let i = 1; i < arguments.length; i++) {
        values[i - 1] = arguments[i];
    }
    if (values && values.length) {
        // logs `Can't resolve all parameters for App: (?)`
        console.error.apply(console, values);
    }
}
